import React from 'react';
import objstr from 'obj-str';
import useTranslation from 'next-translate/useTranslation';
import * as Types from '../../pages/mijn-carel-lurvink/catalogus/stores/types';
import styles from './ProductAttributeSelector.module.scss';

interface IUnitsOfMeasure {
  unitsOfMeasure: Types.UnitOfMeasure[];
  currentUnitOfMeasure: Types.UnitOfMeasure;
  onUnitOfMeasureChange: AppCallbackFn;
}

export const UnitsOfMeasure = ({ unitsOfMeasure, currentUnitOfMeasure, onUnitOfMeasureChange }: IUnitsOfMeasure) => {
  const { t } = useTranslation('product-details');

  return (
    <div className="mb-3">
      <strong className="d-block mb-2">{t('label.unit-of-measure')}</strong>
      <div className={styles.variantAttributes}>
        {unitsOfMeasure.map((unitOfMeasure) => {
          const { code, name } = unitOfMeasure;

          const classNames = objstr({
            [styles.labelOption]: true,
            [styles.selectable]: unitsOfMeasure.length > 1,
            [styles.labelOptionActive]: unitOfMeasure.code === currentUnitOfMeasure.code,
            transition: true
          });

          return (
            <React.Fragment key={`${code}-${name}`}>
              <span className={classNames} onClick={() => onUnitOfMeasureChange({ code })} key={code}>
                {name}
              </span>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
